/*
 *
 *  A module for toggle
 *
 *  Implementation:
 *
 *  import { toggle } from "./components/toggle/toggle.js";
 *  let toggleInstance = new toggle( 'data-link', 'data-target', 'active' );
 *
 */
import { closeAllPopups } from "./../closeAllPopups.js";

export function toggle(link, target, active, clss = [], toParent = false) {
  var elems = document.querySelectorAll("[" + link + "]");

  function selectParent(element, num) {
    var parent = element;
    for (var i = 0; i < num; i++) {
      if (parent.parentNode) {
        parent = parent.parentNode;
      }
    }

    return parent;
  }

  var realLink = link.slice(5);

  elems.forEach(function (elem, index) {
    elem.addEventListener("click", () => {
      let tgts = document.querySelectorAll(
        "[" + target + '="' + elem.dataset[realLink] + '"]'
      );

      closeAllPopups(".js_set_" + realLink + ", .menu .active");

      tgts.forEach(function (tgt, index) {
        if (tgt.classList.contains(active)) {
          tgt.classList.remove(active);

          document.querySelector("body").classList.remove("js_set_" + realLink);

          clss.forEach((cl) => {
            if (toParent > 0) {
              selectParent(tgt, toParent).classList.remove(cl);
            } else {
              tgt.classList.remove(cl);
            }
          });
        } else {
          tgt.classList.add(active);
          document.querySelector("body").classList.add("js_set_" + realLink);

          clss.forEach((cl) => {
            if (toParent > 0) {
              selectParent(tgt, toParent).classList.add(cl);
            } else {
              tgt.classList.add(cl);
            }
          });
        }
      });
    });
  });
}
